import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box } from '@mui/material';
import TextFieldCommon from './TextFieldCommon';
import NestlingRadioType from './NestlingRadioType';
import UploadButtonCommon from './UploadButtonCommon';
import axios from "../../../components/axios";
import { useNavigate } from 'react-router-dom';


const NestlingImageCommon = ({ linkType, setLinkType, urlPath, setURLPath, uploadPath, setUploadPath, imageName, styleButton, styleToggle }) => {
  const navigate = useNavigate();
  const handleImageTypeChange = (
    event: React.MouseEvent<HTMLElement>,
    newImageType: string,
  ) => {
    setLinkType(newImageType);
    if (newImageType === "url"){
      setUploadPath('');
    }else{
      setURLPath('');
    }
  };

  function imagePathChange(e) {
    setURLPath(e.target.value);
  };

  const handleClear = () => {
    setURLPath('');
  };

  //TODO:Add processing
  const handleUploadImage = () => {
    var formData = new FormData();
    var imagefile = document.querySelector('#file');
    formData.append("image", imagefile.files[0]);
    axios.post("/peloton/v1/automation/nestling-image-upload", formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    }).catch(function(err){
      if (!err.response){
        alert(err);
      }else{
        if (err.response.status === 401){
          alert(err.response.data.message);
          navigate("/");
        }else{
          console.log('error.response.status: ', err.response.status);
          console.log('error.response.status: ', err.response.data.message);
          alert(err.response.data.message);
        }
      }
    })
  };


  return (
    <>
    <Box sx={{ pb:'15px'}}>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" sx={{ pt:'5px'}}>
        <Grid item xs={3}>
          <NestlingRadioType value={linkType} onChange={handleImageTypeChange} itemName={imageName} styleToggle={styleToggle}/>
        </Grid>
       { (linkType === 'url') && ( <Grid item xs={9}>
          <TextFieldCommon search={urlPath} searchChange={imagePathChange} handleClear={handleClear} placeholder="Image URL"/></Grid>)}
       { (linkType !== 'url') && ( <Grid item xs={9} >
          <UploadButtonCommon styleButton={styleButton} handleUploadImage={handleUploadImage} fileName={uploadPath} setFileName={setUploadPath}/>
        </Grid>)}
      </Grid>
    </Box>
    </>
  );
};

export default NestlingImageCommon;
